import React from 'react';
import PropTypes from 'prop-types';
import {
  CardContainer, CardImageItem, NewsHeader, DateLine,
} from './css';

const NewsCard = ({
  title, imageSource, date, url,
}) => (
  <CardContainer>
    <a href={url} rel="noopener noreferrer" target="_blank" aria-label={title}>
      <CardImageItem backgroundImageSrc={imageSource} />
    </a>
    <a href={url} rel="noopener noreferrer" target="_blank">
      <NewsHeader>{title}</NewsHeader>
    </a>
    <DateLine>{date}</DateLine>
  </CardContainer>
);

NewsCard.propTypes = {
  title: PropTypes.string,
  imageSource: PropTypes.string,
  date: PropTypes.string,
  url: PropTypes.string,
};

export default NewsCard;
